import React, { FC } from 'react'
import { Table, Spin, Skeleton, Empty } from 'antd'
// import { LoadingOutlined } from '@ant-design/icons'
import { nanoid } from 'nanoid'
import ScrollToTopPagination from '~utils/ScrollToTopPagination'

interface TableMiniProps {
    columns: any
    dataSource: any
    loading?: boolean
    title?: string
    footer?: string
}

const TableMiniComponent: FC<TableMiniProps> = ({ columns, dataSource, loading, title, footer }) => {
    let options: any = {}
    if (title) {
        options['title'] = () => title
    }
    if (footer) {
        options['footer'] = () => footer
    }

    const paginationOptions: any = {
        size: "default",
        defaultPageSize: 25,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100', '200'],
        position: ['topRight', 'bottomRight'],
        locale: { items_per_page: " / Page" },
        showLessItems: (window.screen.width < 768 ? true : false),
    }

    return (
        <Spin spinning={loading} tip="Loading..." size="large" >
            <Table
                columns={columns as any}
                dataSource={dataSource}
                rowKey={() => nanoid()}
                size={'small'}
                bordered={true}
                // loading={loading ? {
                //     spinning: loading,
                //     indicator: <Spin tip="กำลังโหลด..." size="large" />,
                // } : false}
                locale={{
                    emptyText: loading ? <Skeleton active={true} /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }}
                scroll={{ x: true }}
                sticky={{ offsetHeader: window.screen.width > 992 ? 84 : 57 }}
                onChange={ScrollToTopPagination}

                pagination={paginationOptions}
                {...options}
            />
        </Spin>
    )
}
export default TableMiniComponent